export const ptBR = {
  hero: {
    title: 'Tem estação Vammo perto de você?',
    subtitle: 'Digite seu CEP e veja a estação de troca de bateria mais próxima.',
  },
  form: {
    cepLabel: 'Seu CEP',
    cepPlaceholder: '00000-000',
    submit: 'Ver estação mais próxima',
    useLocation: 'Usar minha localização',
    invalidCep: 'Digite um CEP com 8 números.',
    busy: 'Procurando...',
  },
  result: {
    nearestStation: 'Estação mais próxima',
    supportedModels: 'Modelos atendidos',
    distanceNote: 'Distância em linha reta, do seu CEP até a estação.',
    stationsWithin: (count: number, radiusKm: number) =>
      count === 1
        ? `1 estação num raio de ${radiusKm} km`
        : `${count} estações num raio de ${radiusKm} km`,
    openNow: 'Aberta agora',
    closedNow: 'Fechada agora',
    snapshotNotice: 'Lista de estações da última atualização.',
    changeCep: 'Buscar outro CEP',
  },
  ladder: {
    ariaLabel: (range: string) => `Faixa de distância: ${range}`,
    upTo: (km: number) => `até ${km} km`,
    between: (from: number, to: number) => `de ${from} a ${to} km`,
    above: (km: number) => `${km} km ou mais`,
    outOfRegion: 'fora da região atendida',
  },
  bands: {
    excellent: {
      title: 'A rede está ótima na sua região',
      body: 'Você tem estação de troca a poucos minutos de casa. Troque a bateria quando quiser.',
    },
    covered: {
      title: 'Você está bem coberto',
      body: 'A estação mais próxima fica perto de você. Faça a troca na volta do trabalho, mesmo com 50% de bateria. Assim você nunca fica sem carga.',
    },
    limited: {
      title: 'Dá para usar todos os dias, com rotina',
      body: 'Muitos riders nessa distância rodam todos os dias. O segredo é rotina. Troque a bateria sempre no mesmo horário, perto do trabalho ou no caminho de casa. A rede na sua região ainda é limitada e vai crescer.',
    },
    far: {
      title: 'Hoje a rede está longe de você',
      body: 'A estação mais próxima fica longe para o uso diário. Recomendamos esperar uma estação mais perto. Fale com a gente e avisamos quando abrirmos na sua região.',
    },
    out_of_region: {
      title: 'Ainda não chegamos na sua cidade',
      body: 'A Vammo atende hoje a Grande São Paulo. Fale com a gente e avisamos quando chegarmos perto de você.',
    },
  },
  errors: {
    invalid_cep: 'Digite um CEP com 8 números.',
    cep_not_found: 'Não encontramos esse CEP. Confira os números.',
    imprecise:
      'Não conseguimos localizar esse CEP com precisão. Use a localização do celular para ver a estação mais próxima.',
    unavailable: 'A busca falhou agora. Tente de novo ou use sua localização.',
    geolocation_denied: 'Você não permitiu o acesso à localização. Digite seu CEP.',
    geolocation_unavailable: 'Seu navegador não informou a localização. Digite seu CEP.',
    no_stations: 'Não conseguimos carregar as estações agora. Tente de novo.',
  },
  map: {
    unavailable: 'Seu navegador não mostra o mapa. Veja a lista de estações abaixo.',
    listTitle: 'Estações mais próximas',
    youAreHere: 'Você está aqui',
    legend: {
      both: 'Comfort e CPX',
      comfortOnly: 'Só Comfort',
      cpxOnly: 'Só CPX',
    },
  },
  footer: {
    privacy: 'Não guardamos seu CEP nem sua localização.',
    language: 'Idioma',
  },
};
